export const EVENT_IMAGE_MIN_WIDTH = 1920;
export const EVENT_IMAGE_MIN_HEIGHT = 1080;
export const EVENT_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/avif'];
export const EVENT_IMAGE_ACCEPT = EVENT_IMAGE_TYPES.join(',');

export async function validateEventImage(file: File): Promise<void> {
	if (!EVENT_IMAGE_TYPES.includes(file.type)) {
		throw new Error('Use a JPEG, PNG, WebP or AVIF event image.');
	}

	const url = URL.createObjectURL(file);
	try {
		const image = new Image();
		await new Promise<void>((resolve, reject) => {
			image.onload = () => resolve();
			image.onerror = () => reject(new Error('This image could not be read. Choose another file.'));
			image.src = url;
		});

		const { naturalWidth: width, naturalHeight: height } = image;
		if (width < EVENT_IMAGE_MIN_WIDTH || height < EVENT_IMAGE_MIN_HEIGHT) {
			throw new Error(
				`Event images must be at least ${EVENT_IMAGE_MIN_WIDTH} × ${EVENT_IMAGE_MIN_HEIGHT}px. Your image is ${width} × ${height}px. Upload the original high-resolution image.`
			);
		}
		if (width <= height) {
			throw new Error(
				'Use a landscape event image (wider than it is tall). A 16:9 image is recommended.'
			);
		}
	} finally {
		URL.revokeObjectURL(url);
	}
}
